export default __webpack_public_path__ + "static/media/agile.34b00830.svg";